<script>
import moment from "moment";
export default {
  props: ["ticket"],
  data() {
    return {};
  },
  mounted() {
    console.log(this.ticket);
  },
  methods: {
    getLink(v) {
      return process.env.VUE_APP_AWS_CDN + "/" + v;
    },
    async downloadWeekPayout() {
      let file =
        process.env.VUE_APP_AWS_CDN +
        "/payout-sheets/" +
        this.ticket.extra_details.selected_week +
        "--" +
        moment().format("Y") +
        "/" +
        this.ticket.restaurant.name +
        ".xlsx";
      window.open(file, "_blank");
    },
  },
};
</script>

<template>
  <b-card>
    <b-card-header
      >Ticket: # {{ ticket.ticket_id }}
      <p>
        Priority : <b-badge variant="success">{{ ticket.priority }}</b-badge>
      </p>
    </b-card-header>
    <b-card-body>
      <h4 v-if="ticket.category" style="text-transform: capitalize">
        Category : {{ ticket.category.split("_").join(" ") }}
      </h4>
      <h4 v-if="ticket.extra_details.issue" style="text-transform: capitalize">
        Issue : {{ ticket.extra_details.issue.split("_").join(" ") }}
      </h4>
      <h4 v-if="ticket.extra_details.orderId">
        OrderId : {{ ticket.extra_details.orderId }}
      </h4>
      <h4 v-if="ticket.extra_details.selected_week">
        Week: {{ ticket.extra_details.selected_week }}
      </h4>
      <b-row>
        <b-col
          style="margin-block: 10px"
          v-if="this.ticket.extra_details.selected_week"
        >
          <a @click="downloadWeekPayout" style="color: blue; cursor: pointer"
            >Download Payout of week
            {{ this.ticket.extra_details.selected_week }}</a
          >
        </b-col>
      </b-row>
      <template v-if="ticket.extra_details.file?.length">
        Related Link :
        <template v-for="f in ticket.extra_details.file">
          <a
            v-if="ticket.extra_details.file"
            :href="getLink(f)"
            :key="f"
            target="_blank"
            >{{ getLink(f) }}</a
          >
          <br :key="f" />
        </template>
      </template>
      <p v-if="ticket.description">{{ ticket.description }}</p>
      <p v-if="ticket.extra_details.Description">
        {{ ticket.extra_details.Description }}
      </p>
    </b-card-body>
  </b-card>
</template>

<style></style>
